const ingredientNotesFormInitialValues = values => ({
  notes: values.notes,
})

export default ingredientNotesFormInitialValues
